<script setup lang="ts">
import type { Hub } from '@/data/Hubs/types'
import { useUpdateHubMutation } from '@/data/Hubs/useUpdateHubMutation'
import HubDialog, { type HubFormValues } from '@/modules/Workspaces/KnowledgeHub/Hubs/HubDialog.vue'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'

const props = defineProps<{ hub: Hub }>()

const open = defineModel<boolean>({ required: true })
const { workspaceId } = useWorkspaceContext()

const { isPending, error, mutateAsync } = useUpdateHubMutation({ workspaceId })

async function onSubmit(values: HubFormValues) {
  await mutateAsync({
    hubId: props.hub.id,
    name: values.name,
    description: values.description || '',
  })
  open.value = false
}
</script>

<template>
  <HubDialog
    v-model="open"
    title="Edit Hub"
    description="Hub details"
    submit-label="Save"
    :is-pending="isPending"
    :error="error || undefined"
    :initial-values="{ name: hub.name, description: hub.description || '' }"
    @submit="onSubmit"
  />
</template>
